export default "__VITE_ASSET__By3S9o3X__"